import React, { useState } from 'react';
import * as R from 'ramda';
import { StyledTableWrapper, getUpdateDiv, tableRender } from './common';

export const columns = [
  {
    column: 'PASeq',
    label: '流水號',
    className: 'first',
  },
  {
    column: 'event_seq',
    label: '事件順序',
  },
  {
    column: 'runner_seq',
    label: '跑壘順序',
  },
  {
    column: 'fielder.name',
    label: '防守者',
  },
  {
    column: 'position',
    label: '守位',
  },
  {
    column: 'credit',
    label: '動作',
  },
];

export const toChanceList = (PAList) => {
  return R.flatten(
    PAList.map((PA, PAIndex) => {
      return R.flatten(
        PA.runners.map((runner, runnerIndex) => {
          return runner.chances.map((chance) => ({
            PASeq: PAIndex + 1,
            event_seq: runner.event_index + 1,
            runner_seq: runnerIndex + 1,
            ...chance,
          }));
        }),
      );
    }),
  );
};

const FormalGameChances = ({ players, opponentPlayers, PAList, handleUpdate }) => {
  const [selectedRow, setSelectedRow] = useState(-1);
  const [selectColumn, setSelectColumn] = useState('');

  return (
    <div>
      {getUpdateDiv(
        toChanceList(PAList),
        columns,
        setSelectedRow,
        setSelectColumn,
        selectedRow,
        selectColumn,
        handleUpdate,
        {
          pitchers: opponentPlayers,
        },
      )}
      <StyledTableWrapper>
        {tableRender(toChanceList(PAList), columns, setSelectedRow, setSelectColumn, selectedRow, selectColumn)}
      </StyledTableWrapper>
    </div>
  );
};

export default FormalGameChances;
